import { render } from "./[productId].vue?vue&type=template&id=14b7a8c0"
import script from "./[productId].vue?vue&type=script&lang=js"
export * from "./[productId].vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__